module.exports = __webpack_public_path__ + "static/media/1.aa3ab35e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Product/1.jpg
// module id = 261
// module chunks = 0